function StarRating({ count }: { count: number }) {
  const maxStars = 5; // Assuming a maximum of 5 stars
  // Create an array of stars based on the averageReviews
  const stars = Array.from({ length: maxStars }, (_, index) => <i key={index} className={`fa-solid fa-star ${index < count ? 'text-warning' : ''} me-1`}></i>);
  return <div>{stars}</div>;
}

export default StarRating;
